import React from 'react'

interface ChipProps {
  text: string
  isGray?: boolean
}

const Chip: React.FC<ChipProps> = ({ text, isGray }) => {
  return (
    <div
      className={`px-10px flex gap-5px align-center ${
        isGray ? 'radius-full' : 'radius-6'
      }`}
      style={{
        background: `${isGray ? '#EEEFF1' : '#EAF6FA'}`,
        height: '30px',
      }}
    >
      <p>{text}</p>
    </div>
  )
}

export default Chip
